import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogContent, DialogContentText, DialogTitle, Box, Link } from '@mui/material';
import { Group } from '@mui/icons-material';
import Snackbar from '../Snackbar';
import Button from 'components/Button';
import { useTeamContext } from 'contexts/useTeamContext';
import TeamService from 'services/TeamService';
import { getErrorMessage } from 'utils';
import { useAuthUser } from 'features/auth/AuthUserContext';

const Props = {
  token: PropTypes.string,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default function TeamInviteAcceptModal({ token, open, onClose }) {
  const [isBusy, setIsBusy] = useState();
  const [invite, setInvite] = useState();
  const { updateUser } = useAuthUser();
  const [feedback, setFeedback] = useState({ message: '', severity: '' });
  const [, dispatchTeam] = useTeamContext();
  const teamService = new TeamService();

  async function handleAccept() {
    try {
      setIsBusy(true);

      await teamService.acceptInvite(token);

      dispatchTeam();
      await updateUser();

      onClose();
    } catch (e) {
      console.error(e);
      setFeedback({ message: getErrorMessage(e), severity: 'error' });
    } finally {
      setIsBusy(false);
    }
  }

  useEffect(() => {
    async function fetchInvite() {
      try {
        const { data } = await teamService.findInviteByToken(token);

        setInvite(data);
      } catch (e) {
        console.error(e);
        setFeedback({ message: getErrorMessage(e), severity: 'error' });
        onClose();
      }
    }

    if (token) {
      fetchInvite();
    }
  }, [token]);

  return (
    <>
      <Snackbar
        message={feedback.message}
        severity={feedback.severity}
        onClose={() => setFeedback({ message: '', severity: '' })}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      />

      <Dialog maxWidth="xs" fullWidth={true} open={open}>
        <Box p={3} textAlign="center">
          <Group style={{ fontSize: 60 }} />

          <DialogTitle>
            <b>Accept team invitation</b>
          </DialogTitle>

          <DialogContent>
            {invite && (
              <DialogContentText>
                Team <b>{invite.teamData.name}</b> invited you to collaborate.
              </DialogContentText>
            )}
          </DialogContent>

          <Button variant="primary" isInline={true} disabled={isBusy} onClick={handleAccept}>
            Accept invite
          </Button>

          <Box mt={3}>
            <Link onClick={onClose} underline="hover">
              Close
            </Link>
          </Box>
        </Box>
      </Dialog>
    </>
  );
}

TeamInviteAcceptModal.propTypes = Props;
